import { SearchSpace } from 'src/types/api'
import styled, { css } from 'styled-components'
import { Noto_body3_m12, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { ellip } from 'src/styles/mixin'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import React from 'react'
import CouponCircleImage from 'src/components/common/CouponCircleImage'
import { SearchResultPageProps } from 'src/pages/SearchPage/SearchResultPage'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import usePageNav from 'src/hooks/usePageNav.hook'

const SearchRecommendBrand = ({
  RecommendBrandList,
}: Pick<SearchResultPageProps, 'RecommendBrandList'>) => {
  const { brandSalePageNav } = usePageNav()
  return (
    <S.SearchRecommendBrandContainer $option="flex_column">
      <Typography $fontStyle={Noto_subheading_b18}>이 브랜드는 어떠신가요?</Typography>
      <CustomSwiper.Wrap type="default" $wrapstyle={S.SearchRecommendBrandSwiperStyle} gap={20}>
        {RecommendBrandList?.map(
          ({
            BrandName,
            BrandNumber,
            BrandImage,
            CategoryNumber,
          }: SearchSpace.RecommendBrandType) => (
            <CustomSwiper.Item key={BrandNumber}>
              <S.SearchRecommendBrandListItem
                $option="flex_column"
                $width="72px"
                onClick={() => brandSalePageNav(CategoryNumber, BrandNumber, BrandName)}
              >
                <CouponCircleImage src={BrandImage} />
                <S.SearchRecommendBrandName $fontStyle={Noto_body3_m12} $color="var(--black-50)">
                  {BrandName}
                </S.SearchRecommendBrandName>
              </S.SearchRecommendBrandListItem>
            </CustomSwiper.Item>
          ),
        )}
      </CustomSwiper.Wrap>
    </S.SearchRecommendBrandContainer>
  )
}
export default SearchRecommendBrand

const S = {
  SearchRecommendBrandContainer: styled(Container)`
    padding: 30px 20px;
    gap: 12px;
  `,
  SearchRecommendBrandSwiperStyle: css`
    display: flex;
    width: 100%;
  `,
  SearchRecommendBrandListItem: styled(Container)`
    text-align: center;
    gap: 4px;
  `,
  SearchRecommendBrandName: styled(Typography)`
    ${ellip('line2')};
    max-width: 60px;
    text-align: center;
    margin: 0 auto;
  `,
}
